import { render, staticRenderFns } from "./PagePaymentPolicy.vue?vue&type=template&id=a5f850de&scoped=true&"
import script from "./PagePaymentPolicy.vue?vue&type=script&lang=js&"
export * from "./PagePaymentPolicy.vue?vue&type=script&lang=js&"
import style0 from "./PagePaymentPolicy.vue?vue&type=style&index=0&id=a5f850de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f850de",
  null
  
)

export default component.exports